import { Reducer } from "redux";

import { UpdateUserStatusResponse } from "../models/Api/User";
import { UpdateUserStatusDispatchTypes } from "../models/DispatchTypes/User";
import { UpdateUserStatusActionDispatchTypes } from "../constants/User";

export const initialPutState: UpdateUserStatusResponse = {
  loading: false,
  response: false,
  error: null,
};

const UpdateUserStatusReducer: Reducer<
  UpdateUserStatusResponse,
  UpdateUserStatusDispatchTypes
> = (state = initialPutState, action) => {
  switch (action.type) {
    case UpdateUserStatusActionDispatchTypes.UPDATE_USER_STATUS_INVOKE: {
      return {
        ...state,
        loading: true,
        response: false,
        error: null,
      };
    }
    case UpdateUserStatusActionDispatchTypes.UPDATE_USER_STATUS_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
        error: null,
      };
    }

    case UpdateUserStatusActionDispatchTypes.UPDATE_USER_STATUS_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
        response: false,
      };
    }
    case UpdateUserStatusActionDispatchTypes.UPDATE_USER_STATUS_RESET: {
      return initialPutState;
    }
  }
  return state;
};

export default UpdateUserStatusReducer;
